import {Action} from '../../actions';

export const ActionTypes = {
  FETCH_PREVIOUS_FUNDS_LIST_PENDING: 'FETCH_PREVIOUS_FUNDS_LIST_PENDING',
  FETCH_PREVIOUS_FUNDS_LIST_FULFILLED: 'FETCH_PREVIOUS_FUNDS_LIST_FULFILLED',
  FETCH_PREVIOUS_FUNDS_LIST_REJECTED: 'FETCH_PREVIOUS_FUNDS_LIST_REJECTED'
};

export interface FetchPreviousFundsAFulfilledPayload {
  previousFunds: PreviousFund[];
}

export interface PreviousFund {
  Code: string;
  Name: string;
  Aliases?: string[];
  Suggested?: boolean;
}

interface FetchPreviousFundsAction {
  type: string;
}

interface FetchPreviousFundsAFulfilledAction extends Action<FetchPreviousFundsAFulfilledPayload> {
  type: string;
  payload: FetchPreviousFundsAFulfilledPayload;
}

export type PreviousFundActionTypes = FetchPreviousFundsAction | FetchPreviousFundsAFulfilledAction;
